import { defineComponent as _defineComponent } from 'vue'
import ClientUserApi from '@/modules/client/services/ClientUserApi';
import {SmsApiData} from '@/models/LoginData';
import getDevelopmentVerificationCode from '@/commons/services/getDevelopmentVerificationCode';
import {ref, computed} from 'vue';
import EnvironmentService from '@/env/EnvironmentService';
import {useInstance} from '@/composables/useInstance';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmsCodeCheck',
  props: {
    label: null,
    mask: null,
    smsApiData: null,
    additionalParams: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { label: string, mask: string, smsApiData: SmsApiData, additionalParams: Record<string, string> };


const isSent = ref<boolean>(false);
const smsInput = ref<string>('smsInput');
const loading = ref<boolean>(false);
const {$errorHandler, $i18n} = useInstance();
const t = $i18n.useSmsInput;
const verificationCodeLabel = computed(() => t.VERIFICATION_CODE.replace(':', ''));
const generateSms = async() => {
  try {
    await ClientUserApi.sendSms(props.smsApiData.phone, props.additionalParams);
    isSent.value = true;
    if (EnvironmentService.Environment.isPreprodOrDev) {
      props.smsApiData.smsCode = await getDevelopmentVerificationCode(props.smsApiData.phone);
    }
  } catch (e) {
    $errorHandler(e, t.ERROR_SENDING_SMS);
  }
};

return { __sfc: true,props, isSent, smsInput, loading, $errorHandler, $i18n, t, verificationCodeLabel, generateSms }
}

})